import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { createFirstAccessibleUrlTree } from '../navigation/sidebar-nav-items';
import { AccessControlService } from '../services/access-control.service';

/** Redirect away from Dashboard when the user cannot access that module. */
export const dashboardGuard: CanActivateFn = () => {
  const accessControl = inject(AccessControlService);
  const router = inject(Router);

  return accessControl.ensureLoaded().pipe(
    map((loaded) => {
      if (!loaded) {
        return router.createUrlTree(['/login']);
      }
      if (accessControl.hasModuleAccess('dashboard')) {
        return true;
      }
      return createFirstAccessibleUrlTree(router, accessControl);
    }),
  );
};
